import { Injectable } from '@angular/core';
import SlotService from './slot.service';
import ManageTvService from '../customer-offer/manage-tv/manage-tv.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { ICartDetails } from '../interfaces/cart-details.interface';

@Injectable()
export class YourOfferService {

  constructor(
    private slotService: SlotService,
    private manageTvService: ManageTvService,
    private notificationProvider: NotificationProviderService,
  ) {

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CART_DETAILS,
      (cartDetailsResponse: any) => {
        if (!cartDetailsResponse) {
          return;
        }

        this.prepareSlotsModelFromResponse(cartDetailsResponse);
        this.appendGlobalFields(cartDetailsResponse);
      });

    return this.model;
  }

  public model: any = {
    _computedFields: {},
    globalCartMessages: {},
    globalCcdsMessages: {},
    globalOffersMessages: {},
    cartDetails: null,
  };

  private prepareSlotsModelFromResponse(cartDetailsResponse: ICartDetails): void {
    if (!cartDetailsResponse.hasOwnProperty('bundles')) {
      return;
    }

    this.slotService.setInitialData(
      cartDetailsResponse.commonProcessData.actionType,
      cartDetailsResponse.commonProcessData.group.currentlyProcessed
    );

    this.manageTvService.msisdnToManageTv(cartDetailsResponse.msisdnToManageTv);

    this.slotService.prepareBundles(cartDetailsResponse);

    this.slotService.slotsUpdated();
  }

  private appendGlobalFields(cartDetailsResponse: ICartDetails): void {
    this.model._computedFields = {
      showGlobalMessages: cartDetailsResponse.globalCartMessages && cartDetailsResponse.globalCartMessages.messages &&
        cartDetailsResponse.globalCartMessages.messages.length,
      showGlobalCcdsMessages: cartDetailsResponse.globalCcdsMessages && cartDetailsResponse.globalCcdsMessages.messages &&
        cartDetailsResponse.globalCcdsMessages.messages.length,
      showGlobalOffersMessages: cartDetailsResponse.globalOffersMessages && cartDetailsResponse.globalOffersMessages.messages &&
        cartDetailsResponse.globalOffersMessages.messages.length,
    };

    this.model.cartDetails = cartDetailsResponse;
    this.model.globalCartMessages = cartDetailsResponse.globalCartMessages;
    this.model.globalCcdsMessages = cartDetailsResponse.globalCcdsMessages;
    this.model.globalOffersMessages = cartDetailsResponse.globalOffersMessages;
  }
}





